module.exports = __webpack_public_path__ + "img/compras-slick.2b90397d.svg";